<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      :class="['d-flex align-items-center', { 'text-muted': !item.route }]"
      :href="item.route ? $router.resolve({ name: item.route }).href : '#'"
      @click.prevent="!item.route"
      :id="`link-${item.route}`"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-tooltip
        :target="`link-${item.route}`"
        placement="right"
        custom-class="custom-tooltip"
        triggers="hover focus"
        v-if="item.tooltip"
    >
      {{ $t(item.tooltip) }}
    </b-tooltip>
    <b-tooltip
        :target="`link-${item.route}`"
        placement="right"
        custom-class="custom-tooltip"
        triggers="hover focus"
        v-if="item.tooltip"
    >
      <span v-html="$t(item.tooltip)"></span>
    </b-tooltip>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
<style scoped>
.custom-tooltip {
  .tooltip-inner {
    max-width: 400px;
    width: 335px;
  }
}
</style>